import { Injectable } from '@angular/core';
import { SpaEventService } from './spaEvents.service';

@Injectable()
export class ApplicationService {
	public webVersion: string | null = null;

	constructor(private spaEventService: SpaEventService) {}
}
